// Extend the global Window interface for FB and fbAsyncInit
declare global {
  interface Window {
    fbAsyncInit(): void;
  }
  const FB: {
    init(params: FacebookInitParams): void;
    login(callback: (response: FacebookLoginResponse) => void, options?: { scope: string }): void;
  };
}

interface FacebookLoginResponse {
  status: "connected" | "not_authorized" | "unknown";
  authResponse: {
    accessToken: string;
  };
}

// Define the Facebook SDK initialization parameters
interface FacebookInitParams {
  appId?: string;
  autoLogAppEvents: boolean;
  xfbml: boolean;
  version: string;
}

const initFB = () => {
  window.fbAsyncInit = function () {
    FB.init({
      appId: process.env.FACEBOOK_APP_ID,
      autoLogAppEvents: true,
      xfbml: true,
      version: "v17.0",
    });
  };
};

const loadFacebookSDK = (): Promise<Event> => {
  return new Promise(function (resolve, reject) {
    const script = document.createElement("script");
    script.setAttribute("async", "");
    script.setAttribute("defer", "");
    script.setAttribute("crossorigin", "anonymous");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.onload = (event) => {
      initFB();
      resolve(event);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export default loadFacebookSDK;
